(function () {
    var head = document.getElementsByTagName("head")[0];
    if (head) {
        var scriptStyles = document.createElement("link");
        scriptStyles.rel = "stylesheet";
        scriptStyles.type = "text/css";
        scriptStyles.href = "/wp-content/themes/castlegate-minster-baywatch/script-style.css";
        head.appendChild(scriptStyles);
    }
}());
